<script lang="ts">
  /**
   * Меню шестерні: якість і швидкість. Займає всю площу плеєра — у вбудованому
   * плеєрі на телефоні місця на випадну картку над кнопкою просто немає.
   * Закривається дотиком будь-де, зокрема між кнопками: інакше здається, що
   * плеєр завис.
   */
  interface Props {
    /** Висоти доступних якостей, від більшої до меншої. Порожньо — розділу немає. */
    qualities: number[];
    /** Вибрана якість; 0 — авто. */
    quality: number;
    /** Порожньо — розділу немає. */
    speeds: number[];
    speed: number;
    onQuality: (height: number) => void;
    onSpeed: (rate: number) => void;
    onClose: () => void;
  }
  let { qualities, quality, speeds, speed, onQuality, onSpeed, onClose }: Props = $props();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div class="menu" role="dialog" aria-label="Налаштування відтворення" tabindex="-1" onclick={onClose}>
  <div class="sheet">
    {#if qualities.length > 1}
      <div class="group">
        <div class="label">Якість</div>
        <div class="chips">
          <button class:on={quality === 0} onclick={() => onQuality(0)}>Авто</button>
          {#each qualities as h (h)}
            <button class:on={quality === h} onclick={() => onQuality(h)}>{h}p</button>
          {/each}
        </div>
      </div>
    {/if}
    {#if speeds.length > 1}
      <div class="group">
        <div class="label">Швидкість</div>
        <div class="chips">
          {#each speeds as r (r)}
            <button class:on={speed === r} onclick={() => onSpeed(r)}>{r === 1 ? 'Звичайна' : `${r}×`}</button>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .menu {
    position: absolute;
    inset: 0;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: rgba(0, 0, 0, 0.72);
  }
  .sheet {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 420px;
    max-height: 100%;
    overflow-y: auto;
  }
  .label {
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  button {
    padding: 7px 12px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 999px;
    background: transparent;
    color: #fff;
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  button.on {
    border-color: var(--player-accent);
    background: var(--player-accent);
  }
</style>
